import type { DisciplinePaymentLinksStore } from './interfaces'

import { DisciplinePaymentLinksTab, DisciplinePaymentOption } from '../../enums'

export const createDisciplinePaymentLinksState = (): DisciplinePaymentLinksStore => ({
  loading: false,
  products: [],
  paymentOption: DisciplinePaymentOption.Installment,
  autoRenew: true,
  packageId: null,
  installmentId: null,
  discount: 0,
  expiresAt: null,
  calculating: false,
  calculationError: null,
  orderCalculation: null,
  subscriptionCalculation: null,
  generating: false,
  links: [],
  linksTab: DisciplinePaymentLinksTab.PaymentLink,
  senders: [],
  sending: false,
})
